// 小屏（卡片列表）模块
<template>
  <div class="DkbSScreen">
    <div class="listBox"
      :class="[{'mapBg': item.Name === 'Map'}]"
      v-for="(item, index) in List" :key="index">
      <div class="list">
        <!-- 标题 -->
        <p class="listTit" :class="['lt'+item.Title.length]">{{item.Title}}</p>
        <!-- 全屏按钮 -->
        <span class="fsBtn" @click="settingFS(item.Name)" v-if="item.Name === 'NARA'"></span>
        <!-- 内容 -->
        <NARA :sData="item.Data" v-if="item.HasData && item.Name === 'NARA'"></NARA>
        <MR :sData="item.Data" v-if="item.HasData && item.Name === 'MR'"></MR>
        <Access :sData="item.Data" v-if="item.HasData && item.Name === 'Access'"></Access>
        <Cabinet :sData="item.Data" v-if="item.HasData && item.Name === 'Cabinet'"></Cabinet>
        <Map :sData="item.Data" v-if="item.HasData && item.Name === 'Map'"></Map>
        <Humiture :sData="item.Data" v-if="item.HasData && item.Name === 'Humiture'"></Humiture>
        <TCE :sData="item.Data" v-if="item.HasData && item.Name === 'TCE'"></TCE>
        <!-- 暂无数据 -->
        <div class="contentNull" v-if="!item.HasData">
          <img class="img" src="/static/images/dkb/icon_cnull.png" alt="">
          <p class="text"></p>
        </div>
      </div>
    </div>
    <!-- 分页 -->
    <DkbPaging
      :page-index="page" 
      :total="total" 
      :page-size="pageSize" 
      @change="pageChange"
      v-if="total>pageSize">
    </DkbPaging>
  </div>
</template>

<script>
  import DkbPaging from '@/components/DkbPage/Layout/DkbPaging'  // 分页组件
  import NARA from '@/components/DkbPage/SScreen/NARA'           // 档案馆
  import MR from '@/components/DkbPage/SScreen/MR'               // 会议室
  import Access from '@/components/DkbPage/SScreen/Access'       // 门禁
  import Cabinet from '@/components/DkbPage/SScreen/Cabinet'     // 柜体总体数据
  import Map from '@/components/DkbPage/SScreen/Map'             // 地图
  import Humiture from '@/components/DkbPage/SScreen/Humiture'   // 温湿度
  import TCE from '@/components/DkbPage/SScreen/TCE'             // 能耗
  import { dkbApi } from "../../../../static/js/dkb/dkb.js"
  import { showToast } from '../../../../static/js/utility/utility.js';
  let vm

  export default {
    name: 'DkbSScreen',
    components: {
      DkbPaging,
      NARA,
      MR,
      Access,
      Cabinet,
      Map,
      Humiture,
      TCE
    },
    data () {
      return {
        pageSize : 4, //每页显示20条数据
        page : 1, //当前页码
        total : 0, //总记录数
        List: [],
        List1: [
          {
            HasData: true, 
            Name: 'TCE', 
            Data: {}, 
            Title: '能耗'
          },
        ]
      }
    },
    created () {
      vm = this
      // console.log('route', vm.$route)
    },
    mounted() {
      vm.GetAllAuthorityList()
    },
    methods: {
      // 获取所有权限版块列表（小屏）
      async GetAllAuthorityList () {
        let {page, pageSize} = vm
        let res = await dkbApi.GetAllAuthorityList({page, pageSize})
        if (res.ErrCode === 0) {
          vm.page = res.Result.Page
          vm.pageSize = res.Result.PageSize
          vm.total = res.Result.Total
          vm.List = res.Result.List
        } else {
          showToast(res.ErrMsg)
        }
      },
      // 分页变化，更新列表
      pageChange (page) {
        vm.page = page
        vm.GetAllAuthorityList()
      },
      // 设置全屏
      settingFS (name) {
        vm.$router.push('/Dkb/FScreen/'+name)
      }
    },
    watch: {
    }
  }
</script>

<style lang="scss" scoped>
.DkbSScreen {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-content: space-between;
  position: relative;
  .listBox {
    flex-shrink: 0;
    width: 5.96rem;
    height: calc((100% - 0.28rem) / 2);
    padding: 0.57rem 0 0.2rem;
    box-shadow:rgba(0, 0, 0, 0.2) 0px 0px 0.34rem;
    background: url('/static/images/dkb/ss_bg.png') center no-repeat;
    background-size: 5.96rem 100%;
    &.mapBg {
      position: relative;
    }
    &.mapBg::before {
      content: '';
      width: 100%;
      height: 100%;
      background: url('/static/images/dkb/map/map.png') center no-repeat;
      background-size: contain;
      position: absolute;
      right: 0;
      left: 0;
      bottom: 0;
      margin: auto;
    }
    .list {
      width: 100%;
      height: 100%;
      // background: url('/static/images/dkb/ss_bg_c.png') center repeat-y;
      // background-size: 5.96rem 0.05rem;
      position: relative;
      .listTit {
        width: 2.05rem;
        font-size: 0.24rem;
        line-height: 0.3rem;
        text-align: center;
        letter-spacing: 0.05rem;
        position: absolute;
        top: -0.57rem;
        left: 0.11rem;
      }
      .listTit.lt2{
        letter-spacing: 0.38rem;
        text-indent: 0.38rem;
      }
      // 全屏按钮
      .fsBtn {
        width: 0.2rem;
        height: 0.2rem;
        background: url('/static/images/dkb/dbtn_f.png') center no-repeat;
        background-size: 100%;
        position: absolute;
        right: 0.18rem;
        top: -0.4rem;
        z-index: 9;
      }
      // 暂无数据
      .contentNull {
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        justify-items: center;
        .img {
          width: 1.83rem;
        }
        .text {
          width: 1.2rem;
          height: 0.32rem;
          margin-top: 0.17rem;
          background: url(/static/images/dkb/text_cnull.png) center no-repeat;
          background-size: 100%;
        }
        // .text {
        //   margin-top: 0.07rem;
        //   font-size: 0.3rem;
        //   // text-shadow: 0 0 1px rgba(255, 255, 255, 0.24) ;
        //   // -webkit-mask-image:-webkit-gradient(linear, 100% 0, 0 0, from(rgba(6, 20, 42, 1)), to(rgba(8, 40, 68, 1)), color-stop(100%, rgba(0, 0, 0, 0.5))); 
        //   background: linear-gradient(to left, #06142a, #082844);
        //   -webkit-background-clip: text;
        //   color: transparent;
        //   position: relative;
        // }
        // .text:before{content:"暂无数据";
        //   text-shadow:0px 0px 1px rgba(255, 255, 255, 0.8);
        //   position:absolute; left:0px; 
        //   color:rgba(0,0,0,0);
        // }
      }
    }
    // .list::before {
    //   content: '';
    //   display:block;
    //   width: 100%;
    //   height: 0.57rem;
    //   background: url('/static/images/dkb/ss_bg_t.png') center no-repeat;
    //   background-size: 100% 0.57rem;
    //   position: absolute;
    //   left: 0;
    //   top: -0.57rem;
    // }
    // .list::after {
    //   content: '';
    //   display:block;
    //   width: 100%;
    //   height: 0.2rem;
    //   background: url('/static/images/dkb/ss_bg_b.png') center no-repeat;
    //   background-size: 100% 0.2rem;
    //   position: absolute;
    //   left: 0;
    //   bottom: -0.2rem;
    // }
  }
  // 分页
  .DkbPaging,.mo-paging {
    width: 3.75rem;
    // text-align: center;
    display: flex;
    justify-content: center;
    position: absolute;
    left: 4.24rem;
    bottom: -0.67rem;
    z-index: 9;
    .li {
      height: 0.26rem;
      line-height: 0.26rem;
      padding: 0 0.06rem;
      font-size: 0.2rem;
      color: #7da4c8;
    }
    .li+.li{
      margin-left: 0.15rem;
    }
    .li.active {
      line-height: 0.23rem;
      border: 0.01rem solid #7da4c8;
      box-shadow: 0 0 0.03rem rgba(123, 159, 195, 0.41);
    }
    .li.ico {
      font-size: 0.18rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/DkbPage/SScreen/SScreen.vue